<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonservice.showTour">
    <main class="page-content">
        <div class="bgColor">
            <div class="container">
                <div class="row" style="height: 4em;">
                    <div class="col-md-6">
                        <p class="appTitle">Material Subscripton</p>
                    </div>
                    <div class="col-md-6">
                        <p class="adminName">{{ adminName }} <img width="30px" height="30px" style="margin-left:0.5em;"
                                [src]="adminImage" class="rounded-circle"></p>
                    </div>
                </div>

                <div class="row my-4">
                    <div class="col">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-4 searchCol">
                                    <div class="form-inline">
                                        <input class="form-control form-control-sm ml-3 w-75" type="text"
                                            (change)="onChangeEvent($event)" placeholder="Materials" aria-label="Search"
                                            [(ngModel)]="searchval">
                                        <i class="fa fa-search searchIcon" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div class="col-md-3 searchCol">
                                    <button type="button" class="btn btn-primary" (click)="reset()">Reset</button>
                                </div>
                                <div class="col-md-3 searchCol">
                                    <button type="button" class="btn btn-primary addCourseBtn" (click)="openAdd()"><i
                                            class="fa fa-plus" aria-hidden="true"></i> Add Subscription</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="row" *ngIf="showData">
                    <div class="col-md-5 degreeContent" *ngFor="let course of allCourse">
                        <div class="row">
                            <div class="col-md-8">
                                <p style="text-align: left;font-size: 0.8em;">{{ course.courses }}</p>
                            </div>
                            <div class="col-md-4">
                                <i class="fa fa-trash-o iconEdit" #boxCourse (mouseover)="onMouseOver($event)" aria-hidden="true" (click)="deleteCourse(course)"></i>
                                <i class="fa fa-pencil iconEdit" #boxCourse (mouseover)="onMouseOver($event)" (click)="editCourse(course)" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="tableView">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>


                                <tr>
                                    <th>S.NO</th>
                                    <th style="text-align:center;">Category</th>
                                    <th style="text-align:center;">Price</th>
                                    <th style="text-align:center;">Subscription Days</th>
                                    <th style="text-align:center;">Date</th>


                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let subscription of allSubscription;let i = index;"
                                    style="border-bottom:1px solid #ccc !important;">
                                    <tr>
                                        <td style="width:5%;">{{ i+1 }}</td>
                                        <td style="width:15%;text-align:center;" [attr.rowspan]>{{ subscription.category
                                            }}</td>

                                        <td *ngIf="subEdit"><input [(ngModel)]="subscription.price"></td>
                                        <td *ngIf="subEdit"><input [(ngModel)]="subscription.subscription_days"></td>
                                        <td *ngIf="!subEdit" style="text-align:center;">{{ subscription.price }}</td>
                                        <td *ngIf="!subEdit" style="text-align:center;">{{
                                            subscription.subscription_days }}</td>
                                        <td style="text-align:center;">{{ subscription.date | date:'dd/mm/yyyy' }}</td>
                                        <td> <i class="fa fa-trash-o closes" aria-hidden="true"
                                                (click)="deletematerialcategorysubcription(subscription.id)"></i>

                                        </td>
                                        <td style="text-align:center;"><i class="fa fa-pencil iconEdit"
                                                (click)="editsubscription(subscription)" aria-hidden="true"></i></td>
                                                <td>
                                                    <div class="addBtn" *ngIf="subEdit">
                                                        <button class="commonBtn mt-2" (click)="updatematerialsubscription(subscription)"> Submit</button>
                                                    </div>
                                                </td>
                                        <!-- <td style="text-align:center;"><i class="fa fa-trash-o iconEdit" (click)="deleteCourse(coursedata)" aria-hidden="true"></i></td> -->
                                    </tr>
                                    
                                </ng-container>
                                <div class="addBtn" *ngIf="showAdd">
                                    <button class="commonBtn mt-2" (click)="updatematerialsubscription()">

                                        Submit</button>
                                </div>

                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="noData" *ngIf="showNodata">
                    <h2>Currenly No Data Available!</h2>
                </div>

            </div>

            <div class="backdrop" [ngStyle]="{'display':display}"></div>
            <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header" *ngIf="showAdd">
                            Add Material Subscription
                            <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                                <span aria-hidden="true">&times;</span></button>
                        </div>
                        <!-- <div class="modal-header" *ngIf="showEdit">
                            Edit Courses
                            <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                                <span aria-hidden="true">&times;</span></button>
                        </div> -->
                        <div class="dltmodal-content animate modal-body dltBl">
                            <form [formGroup]="courseForm">
                                <label>Category</label>
                                <select class="form-control" formControlName="categorytypeval" addSubject
                                    [(ngModel)]="category">
                                    <option *ngFor="let mcategory of materialdata;let x = index"
                                        [ngValue]="mcategory.id">{{
                                        mcategory.category }}</option>
                                </select>
                                <label>Price</label>
                                <input type="text" class="form-control" formControlName="subjectval"
                                    [(ngModel)]="price">
                                <label>Subscription Days</label>
                                <input type="text" class="form-control" formControlName="yearval" [(ngModel)]="days">

                                <!-- <select class="form-control" formControlName="degreetypeVal" [(ngModel)]="courseName">
                                    <option *ngFor="let degreetype of degreeTypeData;let x = index" [ngValue]="degreetype.id"></option>
                                </select> -->
                                <div class="error-messages">
                                    <div *ngFor="let error of error_messages.subjectval">
                                        <div class="error-message"
                                            *ngIf="courseForm.get('subjectval').hasError(error.type) && (courseForm.get('subjectval').dirty || courseForm.get('subjectval').touched)">
                                            {{ error.message }}
                                        </div>
                                    </div>
                                    <div *ngFor="let error of error_messages.yearval">
                                        <div class="error-message"
                                            *ngIf="courseForm.get('yearval').hasError(error.type) && (courseForm.get('yearval').dirty || courseForm.get('yearval').touched)">
                                            {{ error.message }}
                                        </div>
                                    </div>
                                    <div *ngFor="let error of error_messages.categorytypeval">
                                        <div class="error-message"
                                            *ngIf="courseForm.get('categorytypeval').hasError(error.type) && (courseForm.get('categorytypeval').dirty || courseForm.get('categorytypeval').touched)">
                                            {{ error.message }}
                                        </div>
                                    </div>
                                </div>

                                <div class="addBtn" *ngIf="showAdd">
                                    <button class="commonBtn mt-2" (click)="addSubject1()">
                                        Add
                                        Subcription</button>
                                </div>

                                <!-- <div class="addBtn" *ngIf="showEdit">
                                    <button class="commonBtn mt-2" [disabled]="!courseForm.valid" (click)="updateCourse()">
                                        Update</button>
                                </div> -->
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="backdrop" [ngStyle]="{'display':displayDelete}"></div>
            <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':displayDelete}">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                                <span aria-hidden="true">&times;</span></button>
                        </div>
                        <div class="dltmodal-content animate modal-body dltBl mb-3" style="text-align:center;">
                            <p>Do you want to delete Course ?</p>
                            <button type="submit" class="btn btn-success" (click)="delete()" style="width: 20%;">Yes</button>
                            <button type="submit" class="btn btn-danger" (click)="onCloseHandled()" style="width: 20%;margin-left: 0.3em;">No</button><br><br>
                            <p class="error" *ngIf="showErr">{{ deleteErr }}</p>
                        </div>
                    </div>
                </div>
            </div> -->

        </div>
    </main>
</div>